/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */

// Select the radio inputs inside each `.ds-portlet` and assign a handler
// The atribute `open` is for use with `group-open:tailwind-classes`
// In this node controller should be a `group` class to pair with `group-open`

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["option"];

  initialize() {
    this.checked_classes = ["border-secondary-500", "bg-secondary-50"];
    this.normal_classes = ["border-neutral-300", "bg-white"];
  }

  setChecked(el) {
    el.setAttribute("open", "");
    el.classList.remove(...this.normal_classes);
    el.classList.add(...this.checked_classes);
  }

  setNormal(el) {
    el.removeAttribute("open");
    el.classList.remove(...this.checked_classes);
    el.classList.add(...this.normal_classes);
  }

  selectOption(e) {
    this.optionTargets.forEach((item) => this.setNormal(item));
    this.setChecked(e.currentTarget.closest('[data-ds-portlet-options-target="option"]'));
    e.currentTarget.checked = true;
  }
}
